import { render, staticRenderFns } from "./QuotesWide.vue?vue&type=template&id=9442eb66&scoped=true&"
import script from "./QuotesWide.vue?vue&type=script&lang=ts&"
export * from "./QuotesWide.vue?vue&type=script&lang=ts&"
import style0 from "./QuotesWide.vue?vue&type=style&index=0&id=9442eb66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9442eb66",
  null
  
)

export default component.exports